import React from 'react'
import PropTypes from 'prop-types'
import cx from 'classnames'
import uniqueId from 'lodash/uniqueId'
import { connect } from 'react-redux'

import Tooltip from 'react-wot-bootstrap/lib/components/Tooltip/Tooltip'

import {
    sendHoverSoundCommand,
    sendClickSoundCommand,
} from 'react-wot-bootstrap/lib/helpers/web_to_client'

import { KEY_CODES } from 'constants'

import {
    MENU_URLS,
    PAGES,
    SECTION_TOOLTIPS,
} from './constants'

import styles from './MainMenu.scss'

export class MainMenu extends React.Component {
    static propTypes = {
        craftMachineUrl: PropTypes.string,
        craftMachineEnabled: PropTypes.bool,
        enhancementsEnabled: PropTypes.bool,
        eventRewardsEnabled: PropTypes.bool,
        personalBonusesEnabled: PropTypes.bool,
        battleScheduleEnabled: PropTypes.bool,
        leaderboardsEnabled: PropTypes.bool,
        location: PropTypes.string,
    }

    constructor(props) {
        super(props)

        this.state = {
            isFirstAppear: true,
            activePage: null,
            pages: [],
        }

        this.tooltipId = uniqueId('main-menu-tooltip-id-')
    }

    componentDidMount() {
        const pages = Object.values(PAGES).filter(this.filterPages)
        const activePage = pages.find(page => this.props.location === MENU_URLS[page].url)

        // eslint-disable-next-line react/no-did-mount-set-state
        this.setState({
            pages,
            activePage,
        })
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevState.activePage && prevState.activePage !== this.state.activePage) {
            // eslint-disable-next-line react/no-did-update-set-state
            this.setState({
                isFirstAppear: false,
            })
        }
    }

    handleMouseEnter = () => {
        sendHoverSoundCommand()
    }

    handleMouseDown = (event) => {
        event.preventDefault()
        sendClickSoundCommand()
    }

    handleClick = (page) => (event) => {
        event.preventDefault()
        this.changePage(page)
    }

    handleKeyPress = (page) => (event) => {
        const code = event.keyCode || event.which

        event.preventDefault()

        if (code === KEY_CODES.ENTER) {
            this.changePage(page)
        }
    }

    changePage = (page) => {
        switch (page) {
        case PAGES.craft: {
            return window.location.assign(this.props.craftMachineUrl + '/#' + MENU_URLS[page].url)
        }
        case PAGES.boost: {
            return window.location.assign(this.props.craftMachineUrl + '/#' + MENU_URLS[page].url)
        }
        default: {
            this.setState({
                activePage: page,
            })

            return window.location.assign('/#' + MENU_URLS[page].url)
        }
        }
    }

    getTooltipContent = (page) => {
        return (
            <p className={styles.tooltipMessage}>
                {SECTION_TOOLTIPS[page].title}
            </p>
        )
    }

    filterPages = (page) => {
        const enabledPagesConfig = {
            [PAGES.leaderboards]: this.props.leaderboardsEnabled,
            [PAGES.craft]: this.props.craftMachineEnabled,
            [PAGES.boost]: this.props.enhancementsEnabled,
            [PAGES.rewards]: this.props.eventRewardsEnabled,
            [PAGES.bonuses]: this.props.personalBonusesEnabled,
            [PAGES.battleSchedule]: this.props.battleScheduleEnabled,
        }

        return enabledPagesConfig[page]
    }

    renderItems(items) {
        const { activePage } = this.state

        return items.map((page) => {
            const isActivePage = page === activePage

            const itemClassName = cx(
                styles.item,
                styles[`item__${isActivePage ? 'active' : 'default'}`],
            )

            return (
                <div
                    tabIndex={isActivePage ? -1 : 0}
                    className={itemClassName}
                    onMouseDown={this.handleMouseDown}
                    onMouseEnter={this.handleMouseEnter}
                    onClick={this.handleClick(page)}
                    onKeyPress={this.handleKeyPress(page)}
                    key={`main-menu-${page}`}
                    data-tip={page}
                    data-for={this.tooltipId}
                >
                    <span className={cx(styles.icon, styles[page])} />
                    <span className={cx(styles.iconActive, styles[page])} />
                    <span className={styles.condition} />
                </div>
            )
        })
    }

    render() {
        const { pages, isFirstAppear } = this.state
        const baseClassName = cx(
            styles.base,
            isFirstAppear && styles.base__firstAppear,
        )

        return (
            <div className={baseClassName} style={{ '--count': pages.length }}>
                <div className={styles.wrapper}>
                    <span className={styles.back} />
                    <div className={styles.holder}>
                        <div className={styles.inner}>
                            {this.renderItems(pages)}
                            <span className={styles.caret}>
                                <span className={styles.effects} />
                            </span>
                        </div>
                    </div>
                </div>
                <Tooltip id={this.tooltipId} getContent={this.getTooltipContent} />
            </div>
        )
    }
}

const stateToProps = state => {
    return {
        craftMachineUrl: state.settings.craftMachineUrl,
        craftMachineEnabled: state.craftMachine.is_craft_machine_enabled,
        enhancementsEnabled: state.craftMachine.is_enhancements_enabled,
        eventRewardsEnabled: state.globalMap.event_rewards_enabled,
        personalBonusesEnabled: state.globalMap.personal_bonuses_enabled,
        battleScheduleEnabled: (state.globalMap.battle_schedule_enabled && !!state.wgcwxClanInfo.clan_info.joined_at),
        leaderboardsEnabled: (state.globalMap.leaderboards_enabled && !!state.wgcwxClanInfo.clan_info.joined_at),
        location: state.routing.locationBeforeTransitions.pathname,
    }
}

export default connect(stateToProps, {})(MainMenu)



// WEBPACK FOOTER //
// ./containers/MainMenu/MainMenu.jsx